import React from 'react';
import { FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';

// Same centered floating popup as PG's ViewLogbooks.js .vl-toast — paired
// with the useToast hook's { type, message } shape.
const Toast = ({ toast }) => {
  if (!toast) return null;
  return (
    <div className={`ugtr-toast ugtr-toast-${toast.type}`}>
      {toast.type === 'success' ? <FaCheckCircle /> : <FaExclamationTriangle />}
      {toast.message}
    </div>
  );
};

export default Toast;
